import { Stack } from '@mui/material';
import { useTranslate } from 'react-admin';
import type { AdminApiCredentialListFilters } from '@/api/models';
import { TagsField } from '@/features/operations/filters/TagsField';

interface CredentialsFiltersFormProps {
  filters: AdminApiCredentialListFilters;
  onChange: (patch: Partial<AdminApiCredentialListFilters>) => void;
}

/** Every query parameter `GET /v1/admin/api-credentials` accepts, and no more: `applicationCode`. */
export function CredentialsFiltersForm({ filters, onChange }: CredentialsFiltersFormProps) {
  const translate = useTranslate();

  return (
    <Stack spacing={2.5}>
      <TagsField
        label={translate('pay.credentials.filters.applicationCode')}
        helperText={translate('pay.credentials.filters.applicationCodeHelp')}
        values={filters.applicationCode ?? []}
        onChange={(values) => onChange({ applicationCode: values.length > 0 ? values : undefined })}
      />
    </Stack>
  );
}
